(function($, App, Utils, Components){
  'use strict';

  var logger = new Logger("ProductsListingComponent");

  Components.create('ProductsListingComponent', {

    Selectors: {
      ProductsListingComponent: '.products-listing-component',
      ScrollToProducts: '.scroll-to-products',
      FilterProducts: '.scroll-to-products .filter-products'
	},
	
	scrollToProducts: function() {
	  var _this = this;
	  
	  $(document).ready(function(){
		// Create a map of the get parameters.
	      var getParams = {},
	          paramsList = window.location.search.replace("?", "").split("&");
	      for(var entry in paramsList) {
	          var keyValue = paramsList[entry].split("=");
	          getParams[keyValue[0]] = keyValue[1] || "";
	      }

	      var scrollToProducts = $(_this.Selectors.ScrollToProducts).length > 0;
	      
	      // If any of the following parameters exists, then scroll the window to the products list.
	      if(scrollToProducts && (getParams.invert || getParams.page)) {
	          var productsPosition = $(_this.Selectors.FilterProducts).first().offset().top;
	          console.debug("Scrolling to " + productsPosition + ".");
	          window.scrollTo(0, productsPosition);
	      }
	  });
	  
	},

    init: function() {
      this.scrollToProducts();
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);
